import React from "react";
import { Autocomplete, Box, Chip, TextField } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

export const MANAGED_BY_OPTIONS = [
    { value: "reno", label: "Reno" },
    { value: "contractor", label: "Contractor" },
];

export default function ManagedByFilter({ value = [], onChange }) {
    const selectedOptions = MANAGED_BY_OPTIONS.filter((opt) =>
        value.includes(opt.value),
    );

    return (
        <Box sx={{ width: "100%" }}>
            <Autocomplete
                multiple
                disableCloseOnSelect
                options={MANAGED_BY_OPTIONS}
                value={selectedOptions}
                getOptionLabel={(option) => option.label}
                isOptionEqualToValue={(opt, val) => opt.value === val.value}
                onChange={(_, newOptions) => {
                    onChange(newOptions.map((opt) => opt.value));
                }}
                renderTags={(tagValue, getTagProps) =>
                    tagValue.map((option, index) => (
                        <Chip
                            {...getTagProps({ index })}
                            key={option.value}
                            label={option.label}
                            size="small"
                            deleteIcon={<CloseIcon sx={{ fontSize: 16 }} />}
                            sx={{
                                bgcolor: "rgba(245, 246, 248, 1)",
                                border: "none",
                                fontFamily: "Inter Tight",
                                fontSize: 14,
                                fontWeight: 400,
                                color: "#0D0D0E",
                                "& .MuiChip-deleteIcon": {
                                    color: "rgba(0, 0, 0, 0.54)",
                                    fontSize: 16,
                                    "&:hover": {
                                        color: "rgba(0, 0, 0, 0.87)",
                                    },
                                },
                            }}
                        />
                    ))
                }
                renderInput={(params) => (
                    <TextField
                        {...params}
                        placeholder={
                            selectedOptions.length === 0
                                ? "Managed by"
                                : ""
                        }
                        sx={{
                            "& .MuiOutlinedInput-root": {
                                borderRadius: "8px",
                                backgroundColor: "#F5F6F8",
                                fontFamily: "Inter Tight",
                                fontSize: 14,
                                padding: "4px 8px !important",
                                "& fieldset": {
                                    border: "none",
                                },
                                "&:hover fieldset": {
                                    border: "none",
                                },
                                "&.Mui-focused fieldset": {
                                    border: "none",
                                },
                            },
                        }}
                    />
                )}
                sx={{
                    "& .MuiAutocomplete-inputRoot": {
                        flexWrap: "wrap",
                    },
                }}
            />
        </Box>
    );
}
